const doc = [({"meta":({"forComponent":"ClubSelection", "language":"French"}), "title":"Etape 1", "subtitle":"Entrez le nom de votre club", "searchFieldLabel":"Cherchez par nom de club"})];
module.exports = doc.length <= 1 ? doc[0] : doc;